module.exports = __webpack_public_path__ + "static/media/damandbuilding.31222f19.webp";